import { useEffect, useRef, useState } from 'react';
import MembershipMarketingPlansEdit from './MembershipMarketingPlansEdit';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal';
import { columnsheadId } from '../../universal/columnshead';
import { Button, Select, Space } from 'antd';
import dayjs from 'dayjs';
import MembershipRechargePlansApplicablesMerchants from './MembershipRechargePlansApplicablesMerchants';
import MembershipMarketingPlansApplicablesShops from './MembershipMarketingPlansApplicablesShops'
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import getList from '../../../utilsTsx/universal/getList';

const WebComponent = (props: any) => {
    const ref = useRef<any>(undefined);
    const apiId = 'membershipMarketingPlans';
    const [membershipRechargePlansId, setMembershipRechargePlansId] = useState<any>();
    const [modalVisibleMembershipRechargePlansApplicablesMerchants,
        setModalVisibleMembershipRechargePlansApplicablesMerchants] = useState<any>();
    const [membershipMarketingPlansId, setMembershipMarketingPlansId] = useState<any>();
    const [modalVisibleMembershipMarketingPlansApplicablesShops,
        setModalVisibleMembershipMarketingPlansApplicablesShops] = useState<any>();
    /** 后端数据defaultService */
    const [defaultService, setDefaultService] = useState<string>('');
    const [membershipMarketingPlansModelData, setMembershipMarketingPlansModelData] = useState<any>();
    const [fethcData, setFethcData] = useState<any>();
    const [sendPageData, setSendPageData] = useState<any>({
        showPageData: {}
    });

    useEffect(() => {
        let urlService;
        if (ref.current) {
            urlService = ref.current.defaultService;
            setDefaultService(urlService);
            setFethcData(() => ref.current.fetchData);
        }
        fetchApi.GET(urlService,
            {
                query: {
                    apiId: 'generalData',
                    apiVariable: 'membershipMarketingPlansModel',
                    apiExtend: 'showLists'
                }
            }).then(res => {
                if (res.success) {
                    const { membershipMarketingPlansModel } = res.data;
                    setMembershipMarketingPlansModelData([{ id: 'allMembershipMarketingPlansModel', name: '所有' }, ...membershipMarketingPlansModel]);
                }
            })
    }, []);

    //表头
    const columnsHead = [
        {
            title: '方案',
            dataIndex: 'planName',
        },
        {
            title: '模式',
            dataIndex: 'membershipMarketingPlansModel',
            render: (val: any) => val?.name
        },
        {
            title: '会员类别',
            dataIndex: 'membershipType',
            render: (val: any) => val?.typeName
        },
        {
            title: '使用规则',
            dataIndex: 'isPermanentUse',
            render: (val: boolean, record: any) => {
                return (
                    val === true ?
                        '永久使用' :
                        `${dayjs(record?.startDate).format('YYYY-MM-DD')} 至 ` +
                        `${dayjs(record?.endDate).format('YYYY-MM-DD')}；` +
                        `${record?.totalCopies - record?.usedCopies}/${record?.totalCopies}`
                )
            }
        },
        {
            title: '适合店铺',
            dataIndex: 'id',
            render: (val: any) => (
                <>
                    <Space>
                        <Button type='primary' onClick={() => {
                            setMembershipMarketingPlansId({
                                membershipMarketingPlansId: val
                            })
                            setModalVisibleMembershipMarketingPlansApplicablesShops(true);
                        }}>{'适合店铺'}</Button>
                    </Space>
                </>
            )
        },
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WebUniversalProps = {
        ...props,
        titleName: '营销方案',
        apiId,
        columns,
        serviceId: 'business',
        editOptions: {
            Editor: MembershipMarketingPlansEdit
        }
    };

    return (
        <><Space>
            <Select
                showSearch
                placeholder="模式"
                optionFilterProp="children"
                defaultValue={'allMembershipMarketingPlansModel'}
                onChange={(e) => {
                    const cs = {
                        showPageData: {
                            ...sendPageData.showPageData,
                            membershipMarketingPlansModelId: e
                        }
                    }
                    setSendPageData(cs);
                    fethcData({
                        apiId,
                        sendPageData: cs
                    });
                }}
                style={{ width: 130 }}
                filterOption={(input, option: any) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                {getList.general(membershipMarketingPlansModelData)}
            </Select>
        </Space>
            <> </>
            <WebUniversal {...extendProps} ref={ref} />
            {modalVisibleMembershipRechargePlansApplicablesMerchants ?
                (<MembershipRechargePlansApplicablesMerchants
                    closeModal={() => setModalVisibleMembershipRechargePlansApplicablesMerchants(false)}
                    data={membershipRechargePlansId} />)
                : null}
            {modalVisibleMembershipMarketingPlansApplicablesShops ?
                (<MembershipMarketingPlansApplicablesShops
                    closeModal={() => setModalVisibleMembershipMarketingPlansApplicablesShops(false)}
                    data={membershipMarketingPlansId} />)
                : null}
        </>
    )
}

export default WebComponent;
